// extracted by mini-css-extract-plugin
export default {"modalContent":"modalContent-Z1RSi","closeButtonWrapper":"closeButtonWrapper-K8DUc","leftRightButtonWrapper":"leftRightButtonWrapper-P9Nug"};